import React, { Component } from "react";
import { RouteComponentProps } from "react-router";
import { PaginationHeaderYear } from "./../../Constants/Util";
import Datatable from "../../Constants/Datatable";
import { SEARCH_ICON, PENCIL, LOGOUT_ICON } from "../../Constants/SrcImages";
import { Row, Col, Label, Container } from "reactstrap";
import { COLUMNS_ADMIN_GRADES_CONTA } from "../../Constants/DatatableColumns";
import { ModalMontos } from "./../../Constants/Modal";
import moment from "moment";
import { getGrades, getMonto, postMontos, putMonto, putDeleteMontoDates, postMontoDates, putMontoDates } from "../../Constants/Services";
import { IGrades, IMonto, IMontoDate } from "./../../Constants/Interfaces";

interface ICuentasState {
  year: string;
  dataGrade: IGrades[];
  formGrade: IGrades;
  formMonto: IMonto;
  formMontoDate: IMontoDate;
  dataMontoDate: IMontoDate[];
  isOpenModalCuentas: boolean;
  isOpenModalDates: boolean;
  msg_error: string;
  loading: boolean;
  n_mes: string;
}

class Montos extends Component<RouteComponentProps<{}>, ICuentasState> {
  constructor(props: any) {
    super(props);
    this.state = {
      year: new Date().getFullYear().toString(),
      dataGrade: [],
      dataMontoDate: [],
      formGrade: {
        gr_id: "",
        gr_alias: "",
        gr_desc: "",
      },
      formMonto: {
        mt_id: "",
        mt_grade: "",
        mt_year: "",
        mt_mensualidad_r: "",
        mt_mensualidad_hm: "",
        mt_mensualidad_hd: "",
        mt_matricula_r: "",
        mt_matricula_hm: "",
        mt_matricula_hd: "",
        mt_plataforma: "",
        mt_laboratorio: "",
        mt_efisica: "",
        mt_otro_monto: "",
        mt_otro_desc: "",
        mt_a_robotica:"",
        mt_robotica:"",
        mt_anualidad_r: "",
        mt_anualidad_hm: "",
        mt_anualidad_hd: "",
        mt_a_plataforma: "",
        mt_a_laboratorio: "",
        mt_a_efisica: "",
        t_status: "",
      },
      formMontoDate: {
        mtd_id: "",
        mtd_monto: "",
        mtd_date: new Date().toString(),
        mtd_mes_number: "",
        mtd_status: "",
      },
      msg_error: "",
      isOpenModalDates: false,
      isOpenModalCuentas: false,
      loading: false,
      n_mes: "",
    };
    this.changeHeader = this.changeHeader.bind(this);
    this.fetchGrade = this.fetchGrade.bind(this);
    this.columnModalSearchCuentas = this.columnModalSearchCuentas.bind(this);
    this.handleModalAddCuentas = this.handleModalAddCuentas.bind(this);
    this.onChangeMontoDates = this.onChangeMontoDates.bind(this);
    this.onChangeMonto = this.onChangeMonto.bind(this);
    this.saveMontoDate = this.saveMontoDate.bind(this);
    this.handleModalAddDates = this.handleModalAddDates.bind(this);
    this.saveMontoFechas = this.saveMontoFechas.bind(this);
    this.columnModalEditDates = this.columnModalEditDates.bind(this);
    this.handlerEditDates = this.handlerEditDates.bind(this);
    this.fetchMonto = this.fetchMonto.bind(this);
    this.deleteMontoFechas = this.deleteMontoFechas.bind(this);
  }

  async fetchGrade() {
    const response = await getGrades();
    this.setState({
      dataGrade: response,
      loading: false,
      msg_error: "",
    });
  }

  async fetchMonto({ gr_id }) {
    const response = await getMonto(gr_id, this.state.year);
    if (response.mt !== undefined) {
      this.setState({
        formMonto: response.mt[0],
        dataMontoDate: response.mtd,
        n_mes: response.n_mes[0].n_mes,
        loading: false,
      });
    } else {
      this.setState({
        dataMontoDate: [],
        formMonto: {
          mt_id: "",
          mt_grade: "",
          mt_year: "",
          mt_mensualidad_r: "",
          mt_mensualidad_hm: "",
          mt_mensualidad_hd: "",
          mt_matricula_r: "",
          mt_matricula_hm: "",
          mt_matricula_hd: "",
          mt_plataforma: "",
          mt_robotica:"",
          mt_a_robotica:"",
          mt_laboratorio: "",
          mt_efisica: "",
          mt_otro_monto: "",
          mt_otro_desc: "",
          mt_anualidad_r: "",
          mt_anualidad_hm: "",
          mt_anualidad_hd: "",
          mt_a_plataforma: "",
          mt_a_laboratorio: "",
          mt_a_efisica: "",
          t_status: "",
        },
        msg_error: "",
        loading: false,
      });
    }
  }

  componentDidMount() {
    this.fetchGrade();
  }

  changeHeader({ year, operation }: any) {
    var currentYear = new Date();

    var result = year;
    if (operation === "left") result = parseInt(year) - 1;
    else {
      result = parseInt(year) + 1;
      if (result > currentYear.getFullYear()) result = currentYear.getFullYear();
    }
    this.setState({
      year: result,
    });
  }

  handlerSearchMonto = (row: any) => {
    this.setState((prevState) => ({
      isOpenModalCuentas: !prevState.isOpenModalCuentas,
      formGrade: row,
    }));
    this.fetchMonto({ gr_id: row.gr_id });
  };

  handlerEditDates = (row: any) => {
    this.setState({
      formMontoDate: row,
    });
  };

  columnModalSearchCuentas(cell, row) {
    return (
      <Row>
        <Col xs={12} className="d-flex">
          <Label className="txt-underline" onClick={() => this.handlerSearchMonto(row)}>
            {row.gr_id}
          </Label>
          <img className="img-search-icon" onClick={() => this.handlerSearchMonto(row)} src={SEARCH_ICON} alt="" />
        </Col>
      </Row>
    );
  }

  columnModalEditDates(cell, row) {
    return (
      <Row>
        <Col xs={12} className="d-flex">
          <Label className="txt-underline" onClick={() => this.handlerEditDates(row)}>
            {row.mtd_mes_number}
          </Label>
          <img className="img-search-icon" onClick={() => this.handlerEditDates(row)} src={PENCIL} alt="" />
          <img className="img-search-icon" onClick={() => this.deleteMontoFechas(row)} src={LOGOUT_ICON} alt="" />
        </Col>
      </Row>
    );
  }

  onChangeMonto(e: any) {
    this.setState({
      formMonto: {
        ...this.state.formMonto,
        [e.target.name]: e.target.value,
      },
      msg_error: "",
    });
  }

  onChangeMontoDates(date: any) {
    this.setState({
      formMontoDate: {
        ...this.state.formMontoDate,
        mtd_date: date,
      },
      msg_error: "",
    });
  }

  handleModalAddCuentas() {
    this.setState((prevState) => ({
      isOpenModalCuentas: !prevState.isOpenModalCuentas,
      dataMontoDate: [],
      formMonto: {
        mt_id: "",
        mt_grade: "",
        mt_year: "",
        mt_mensualidad_r: "",
        mt_mensualidad_hm: "",
        mt_mensualidad_hd: "",
        mt_matricula_r: "",
        mt_matricula_hm: "",
        mt_matricula_hd: "",
        mt_plataforma: "",
        mt_laboratorio: "",
        mt_robotica:"",
        mt_efisica: "",
        mt_otro_monto: "",
        mt_otro_desc: "",
        mt_anualidad_r: "",
        mt_anualidad_hm: "",
        mt_anualidad_hd: "",
        mt_a_plataforma: "",
        mt_a_robotica: "",
        mt_a_laboratorio: "",
        mt_a_efisica: "",
        t_status: "",
      },
      msg_error: "",
    }));
  }

  handleModalAddDates() {
    this.setState((prevState) => ({
      isOpenModalDates: !prevState.isOpenModalDates,
    }));
  }

  deleteMontoFechas(row) {
    const propsGrade = this.state.formGrade;
    const body = {
      mtd_id: row.mtd_id,
    };
    putDeleteMontoDates(body);

    this.setState((prevState) => ({
      formMontoDate: {
        mtd_id: "",
        mtd_monto: "",
        mtd_date: new Date().toString(),
        mtd_mes_number: "",
        mtd_status: "",
      },
    }));
    setTimeout(() => {
      this.fetchMonto({ gr_id: propsGrade.gr_id });
    }, 1000);
  }

  saveMontoFechas() {
    const props = this.state.formMontoDate;
    const propsFormMonto = this.state.formMonto;
    const propsGrade = this.state.formGrade;
    if (props.mtd_monto.length > 0) {
      const body = {
        mtd_id: props.mtd_id,
        mtd_date: moment(props.mtd_date).format("YYYY-MM-DD HH:mm:ss"),
      };
      putMontoDates(body);
    } else {
      if (propsFormMonto.mt_id.length > 0) {
        const body = {
          mtd_monto: propsFormMonto.mt_id,
          mtd_mes_number: Number(this.state.n_mes) + 1,
          mtd_date: moment(props.mtd_date).format("YYYY-MM-DD HH:mm:ss"),
        };
        postMontoDates(body);
      } else {
        this.setState({
          msg_error: "No tienes montos registados",
        });
      }
    }

    this.setState((prevState) => ({
      formMontoDate: {
        mtd_id: "",
        mtd_monto: "",
        mtd_date: new Date().toString(),
        mtd_mes_number: "",
        mtd_status: "",
      },
    }));
    setTimeout(() => {
      this.fetchMonto({ gr_id: propsGrade.gr_id });
    }, 1000);
  }

  saveMontoDate() {
    const props = this.state.formMonto;
    const propsGrade = this.state.formGrade;
    if (props.mt_id.length === 0) {
      const body = {
        mt_grade: propsGrade.gr_id,
        mt_year: this.state.year,
        mt_mensualidad_r: props.mt_mensualidad_r,
        mt_mensualidad_hm: props.mt_mensualidad_hm,
        mt_mensualidad_hd: props.mt_mensualidad_hd,
        mt_matricula_r: props.mt_matricula_r,
        mt_matricula_hm: props.mt_matricula_hm,
        mt_matricula_hd: props.mt_matricula_hd,
        mt_plataforma: props.mt_plataforma,
        mt_laboratorio: props.mt_laboratorio,
        mt_efisica: props.mt_efisica,
        mt_otro_monto: props.mt_otro_monto,
        mt_otro_desc: props.mt_otro_desc,
        mt_anualidad_r: props.mt_anualidad_r,
        mt_anualidad_hm: props.mt_anualidad_hm,
        mt_anualidad_hd: props.mt_anualidad_hd,
        mt_a_plataforma: props.mt_a_plataforma,
        mt_a_laboratorio: props.mt_a_laboratorio,
        mt_a_efisica: props.mt_a_efisica,
        mt_a_robotica:props.mt_a_robotica,
        mt_robotica:props.mt_robotica
      };
      postMontos(body);
      setTimeout(() => {
        this.fetchMonto({ gr_id: propsGrade.gr_id });
      }, 1000);
    } else {
      const body = {
        mt_id: props.mt_id,
        mt_mensualidad_r: props.mt_mensualidad_r,
        mt_mensualidad_hm: props.mt_mensualidad_hm,
        mt_mensualidad_hd: props.mt_mensualidad_hd,
        mt_matricula_r: props.mt_matricula_r,
        mt_matricula_hm: props.mt_matricula_hm,
        mt_matricula_hd: props.mt_matricula_hd,
        mt_plataforma: props.mt_plataforma,
        mt_laboratorio: props.mt_laboratorio,
        mt_efisica: props.mt_efisica,
        mt_otro_monto: props.mt_otro_monto,
        mt_otro_desc: props.mt_otro_desc,
        mt_anualidad_r: props.mt_anualidad_r,
        mt_anualidad_hm: props.mt_anualidad_hm,
        mt_anualidad_hd: props.mt_anualidad_hd,
        mt_a_plataforma: props.mt_a_plataforma,
        mt_a_laboratorio: props.mt_a_laboratorio,
        mt_a_efisica: props.mt_a_efisica,
        mt_a_robotica:props.mt_a_robotica,
        mt_robotica:props.mt_robotica
      };

      putMonto(body);
      setTimeout(() => {
        this.fetchMonto({ gr_id: propsGrade.gr_id });
      }, 1000);
    }
    this.setState({ loading: true });
  }

  render() {
    const props = this.state;
    return (
      <React.Fragment>
        {props.isOpenModalCuentas && (
          <ModalMontos
            title="Agregar Monto"
            formGrade={props.formGrade}
            dataFMonto={props.formMonto}
            dataMontoDates={props.dataMontoDate}
            dataFormMontoDates={props.formMontoDate}
            onChange={this.onChangeMonto}
            onChangeMontoDates={this.onChangeMontoDates}
            isOpen={props.isOpenModalCuentas}
            toggle={this.handleModalAddCuentas}
            toggleSave={this.saveMontoDate}
            msg_error={props.msg_error}
            saveMontoFechas={this.saveMontoFechas}
            columnModalEditDates={this.columnModalEditDates}
            loading={props.loading}
          />
        )}
        <Container className="mt-4">
          <Row>
            <Col sm={12} className="text-center">
              <Label className="font-weight-bold">
                <h3>Montos</h3>
              </Label>
            </Col>
            <Col sm={12} className="text-center">
              <PaginationHeaderYear year={props.year} changeHeader={this.changeHeader} />
            </Col>
            <Col sm={12}>
              <Datatable
                data={props.dataGrade}
                columns={COLUMNS_ADMIN_GRADES_CONTA(this.columnModalSearchCuentas)}
                keyProp="gr_id"
                exportD={false}
                searchs={true}
                selectRows={false}
                optionSelectRow={null}
              />
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}
export default Montos;
